import Page from 'common/components/page/Page';
import { PageTemplates } from 'common/components/page/PageTemplates';
import { Button, Card } from 'react-bootstrap';
import Alert from 'common/components/alert/Alert';
import AlertType from 'common/types/AlertType';
import { isActionCompleteFail } from 'common/services/api/isActionCompleteFail';
import { Form } from 'react-final-form';
import { ActionCompleteResponse } from 'common/types/ApiResponse';
import FinalFormField from 'common/components/final-form/FinalFormField';
import { QuestionsList } from './QuestionsList';
import { ResetPassForm } from './ResetPassForm';

interface ISecurtiyQuestionsPresenter {
  questionsError: string | null;
  answerSubmitResponse: ActionCompleteResponse | null;
  data: QuestionsList | null;

  onSubmit: (values: ResetPassForm) => void;
  submitting: boolean;
}
function SecurtiyQuestionsPresenter(props: ISecurtiyQuestionsPresenter) {
  return (
    <Page template={PageTemplates.centered}>
      <Card>
        <Card.Body>
          {isActionCompleteFail(props.answerSubmitResponse) && (
            <Alert type={AlertType.danger}>
              <ul>
                {props.answerSubmitResponse.payload.errorInfo?.errorItems?.map(
                  (error, i = 0) => (
                    <li key={i++}>{error}</li>
                  )
                )}
              </ul>
            </Alert>
          )}

          {props.questionsError && (
            <Alert type={AlertType.danger}>{props.questionsError}</Alert>
          )}

          {props.data &&
            props.data.questions &&
            props.data.questions.length >= 3 && (
              <Form<ResetPassForm> onSubmit={props.onSubmit}>
                {({ handleSubmit }) => (
                  <form onSubmit={handleSubmit}>
                    {props.data?.questions.map((item, index) => {
                      return (
                        <FinalFormField
                          name={'answer' + index}
                          label={item.question}
                          type='text'
                          key={item.id}
                        />
                      );
                    })}
                    <Button
                      type='submit'
                      variant='primary'
                      disabled={props.submitting}
                    >
                      Submit
                    </Button>
                  </form>
                )}
              </Form>
            )}
          {props.data &&
            props.data.questions &&
            props.data.questions.length === 0 && (
              <Alert type={AlertType.danger}>
                This profile does not have security questions
              </Alert>
            )}
        </Card.Body>
      </Card>
    </Page>
  );
}

export default SecurtiyQuestionsPresenter;
